import { Typography } from "@mui/material";

export const HomePage = () => {
  return (
    <div>
      <Typography variant="h3" gutterBottom>
        Welcome to Dynamic Forms!
      </Typography>
      <Typography variant="body1">
        This is the home page of the Dynamic Forms application.
      </Typography>
    </div>
  );
};
